// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    // Verifica sessão ativa ao carregar
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        carregarPerfil(session.user);
      } else {
        setCarregando(false);
      }
    });

    // Escuta mudanças de autenticação
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        carregarPerfil(session.user);
      } else {
        setUsuario(null);
        setCarregando(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function carregarPerfil(user) {
    try {
      const { data, error } = await supabase
        .from('colaboradores')
        .select('*')
        .eq('user_id', user.id)
        .single();

      if (error || !data) {
        // Perfil não encontrado — cria um básico
        setUsuario({
          id: user.id,
          nome: user.email,
          email: user.email,
          perfil: 'sdr',
          nivel: 'sdr',
        });
      } else {
        setUsuario({
          id: user.id,
          nome: data.nome,
          email: data.email,
          perfil: data.nivel,
          nivel: data.nivel,
          cargo: data.cargo,
          cor: data.cor,
          foto_url: data.foto_url || null,
          funis: data.funis,
          acesso: data.acesso,
        });
      }
    } catch (e) {
      console.error('Erro ao carregar perfil:', e);
    } finally {
      setCarregando(false);
    }
  }

  async function login(email, senha) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: senha });
    if (error) throw error;
    return data;
  }

  async function logout() {
    await supabase.auth.signOut();
    setUsuario(null);
  }

  function temPermissao(perfisPermitidos) {
    if (!usuario) return false;
    return perfisPermitidos.includes(usuario.perfil);
  }

  const valor = {
    usuario,
    carregando,
    login,
    logout,
    temPermissao,
    eAdmin:  usuario?.perfil === 'admin',
    eGestor: ['admin', 'gestor'].includes(usuario?.perfil),
    eSDR:    usuario?.perfil === 'sdr',
    eCloser: usuario?.perfil === 'closer',
  };

  return (
    <AuthContext.Provider value={valor}>
      {!carregando && children}
    </AuthContext.Provider>
  );
}
